// src/features/auth/Routes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import ChangelogPage from './pages/Changelog';

export const ChangelogRoutes = () => (
  <>
    <Route path="/changelog" element={<ChangelogPage />} />
  </>
);